import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { BulkTest, BulkTestCreate } from "@/model";
import bulkTestRepository from "@/repository/bulkTestRepository";
import { bulkTestQueryKeys } from "./keys";


export const useCreateBulkTest = (agentId: number) => {
    const queryClient = useQueryClient();

    return useMutation<BulkTest, AxiosError, BulkTestCreate>({
        mutationKey: ["bulk-test", "create"],
        mutationFn: async (form: BulkTestCreate) => {
            try {
                const { data } = await bulkTestRepository.create(agentId, form);
                return data;
            } catch (e) {
                throw e;
            }
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: bulkTestQueryKeys.pageAll(agentId),
                exact: false
            });
        }
    });
};
